var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallWhiteRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.11328 6.20703C9.25391 6.80469 9.32422 7.56055 9.32422 8.47461C9.32422 9.37695 9.25391 10.1328 9.11328 10.7422L3.45312 16.1738C2.83203 16.0801 2.28125 15.793 1.80078 15.3125C1.32031 14.832 0.986328 14.2812 0.798828 13.6602L5.91406 8.7207L6.26562 8.47461L5.91406 8.21094L0.798828 3.28906C0.986328 2.66797 1.32031 2.11719 1.80078 1.63672C2.28125 1.15625 2.83203 0.863281 3.45312 0.757812L9.11328 6.20703Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallWhiteRightArrow);
export default __webpack_public_path__ + "static/media/small_white_right_arrow.cc6f4d2424a615df51a1f3d5b3149ec0.svg";
export { ForwardRef as ReactComponent };